import { QuestionStyle } from './enums';
import { QuestionRadioBoxes } from './QuestionRadioBoxes';
import { QuestionRadioCards } from './QuestionRadioCards';
import { type QuestionProps, type RadioSelected, type StepProps } from './types';

export function StepComponent({
  question,
  options,
  disabled,
  selected,
  onChangeSelection
}: StepProps) {
  const questionOptions = [...options];

  if (question.data.other) {
    questionOptions.push('other');
  }

  const props = {
    questionId: question.id,
    questionOptions,
    questionLayout: question.layout,
    selected,
    disabled,
    onChangeSelection
  } as QuestionProps<RadioSelected>;

  if (question.style === QuestionStyle.RadioBoxes) {
    return <QuestionRadioBoxes key={question.id} {...(props as QuestionProps<RadioSelected>)} />;
  }

  // QuestionStyle.RadioCards
  return <QuestionRadioCards key={question.id} {...(props as QuestionProps<RadioSelected>)} />;
}
